import { useEffect } from 'react'
import { useTaskPanel } from '../contexts/TaskPanelContext'
import { TaskList } from './TaskList'
import './TaskPanel.css'

export function TaskPanel() {
  const { isOpen, closePanel } = useTaskPanel()

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        closePanel()
      }
    }
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, closePanel])

  if (!isOpen) return null

  return (
    <>
      <div className="task-panel-overlay" onClick={closePanel} />
      <div className={`task-panel ${isOpen ? 'open' : ''}`}>
        <div className="task-panel-header">
          <h2>Tasks</h2>
          <button
            className="task-panel-close"
            onClick={closePanel}
            aria-label="Close task panel"
            title="Close"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="task-panel-body">
          <TaskList />
        </div>
      </div>
    </>
  )
}
































